import {BaseTerms} from "../../infrastructure/models/base-terms";

export class AthletePropositionBetModuleTerms extends BaseTerms {}
